"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeFacade = exports.HighchartsDateFormatByFunctionality = exports.HighchartsDateFormats = exports.DateTimeFormatByFunctionality = exports.DateTimeFormats = exports.DAY_IN_MILLIS = void 0;
const moment_range_1 = require("moment-range");
const moment_timezone_1 = __importDefault(require("moment-timezone"));
moment_timezone_1.default.locale("en");
moment_timezone_1.default.tz.setDefault("UTC");
// @ts-ignore
const GlobalMoment = (0, moment_range_1.extendMoment)(moment_timezone_1.default);
exports.DAY_IN_MILLIS = 24 * 60 * 60 * 1000;
exports.DateTimeFormats = {
    DayMonth: "DD.MM",
    DayMonthUS: "MM/DD",
    DayMonthYear: "DD.MM.YYYY",
    DayMonthYearUS: "MM/DD/YYYY",
    MonthNameDayYearTime: "lll",
    MonthNameDayYearTimeWithTimezone: "lll z",
    MonthDayYearTime: "MMM D, YYYY H:mm:ss",
    MonthDayYearTimeUS: "MMM D, YYYY h:mm:ssa",
    MonthDayYearTimeWithMillis: "MMM D, YYYY H:mm:ss.SSS",
    MonthDayYearTimeWithMillisUS: "MMM D, YYYY h:mm:ss.SSSa",
};
exports.DateTimeFormatByFunctionality = {
    HumanReadable: {
        Common: {
            DateOnly: exports.DateTimeFormats.DayMonthYearUS,
        },
        Project: {
            Members: {
                CreatedDate: exports.DateTimeFormats.MonthNameDayYearTimeWithTimezone
            }
        },
    }
};
/**
 https://api.highcharts.com/class-reference/Highcharts#.dateFormat

 Defaults
 {
        millisecond: '%H:%M:%S.%L',
        second: '%H:%M:%S',
        minute: '%H:%M',
        hour: '%H:%M',
        day: '%e. %b',
        week: '%e. %b',
        month: '%b \'%y',
        year: '%Y'
    }
 */
exports.HighchartsDateFormats = {
    HourMinute: "%H:%M",
    HourMinuteUS: "%l:%M%P",
    DayMonth: "%e.%m",
    DayMonthUS: "%m/%d",
    DayMonthYearUS: "%m-%d-%Y",
    DayMonthWithZeros: "%d.%m",
    DayMonthTimeWithZeros: "%d.%m %H:%M",
    timeWithZeros: "%H:%M",
    DayNameMonthDay: "%a, %b %e",
    DayNameMonthDayTime: "%a, %b %e, %l:%M%P", //Sunday, May 3, 12:56
};
exports.HighchartsDateFormatByFunctionality = {
    Common: {
        tooltip: {
            hourly: exports.HighchartsDateFormats.DayNameMonthDayTime,
            daily: exports.HighchartsDateFormats.DayNameMonthDay,
        },
        xAxis: {
            dateTimeLabelFormats: {
                day: exports.HighchartsDateFormats.DayMonthUS,
                hour: exports.HighchartsDateFormats.HourMinuteUS,
                minute: exports.HighchartsDateFormats.HourMinuteUS,
            }
        },
        export: {
            credits: exports.HighchartsDateFormats.DayMonthYearUS
        }
    }
};
const Formatters = {
    HumanReadable: {
        Common: {
            formatToDateLocalizedFormat: (moment) => moment.format(exports.DateTimeFormatByFunctionality.HumanReadable.Common.DateOnly),
        },
    }
};
const now = () => new Date().getTime();
const getStartOfDayMilliseconds = (timeMillis) => timeMillis - (timeMillis % exports.DAY_IN_MILLIS);
const getStartOfTodayMilliseconds = () => getStartOfDayMilliseconds(now());
const getMillisecondsFromDayStart = (timeMillis) => Math.floor(timeMillis % exports.DAY_IN_MILLIS);
exports.DateTimeFacade = {
    getStartOfDayMilliseconds,
    getStartOfTodayMilliseconds,
    getMillisecondsFromDayStart,
    Formatters: Formatters,
    getMomentFromMillis: (millis) => {
        const momentValue = (0, moment_timezone_1.default)(millis);
        if (process.env.NODE_ENV === "development" && !momentValue.isValid()) {
            throw new Error("millis cannot be parsed to Moment: " + millis);
        }
        return momentValue;
    },
    getMomentFromCurrentTime: () => (0, moment_timezone_1.default)(),
    getMomentFromCurrentDay: () => exports.DateTimeFacade.getMomentFromCurrentTime().endOf('day'),
    getMomentRange: (fromMoment, toMoment) => {
        return GlobalMoment.range(fromMoment.toDate(), toMoment.toDate());
    },
    getMomentFromCurrentDayEndOf: () => exports.DateTimeFacade.getMomentFromCurrentTime().endOf('day'),
    getWeekDayIndex: () => {
        const momentFromCurrentDay = exports.DateTimeFacade.getMomentFromCurrentDay();
        const startOfWeek = momentFromCurrentDay.clone().startOf("isoWeek");
        return momentFromCurrentDay.diff(startOfWeek, "day");
    },
    getArrayOfDiffsByUnit: (momentRange, unit) => {
        return Array.from(momentRange.by(unit)).map(m => Math.abs(m.diff(momentRange.end, unit)));
    },
    getArrayOfUnits: (momentRange, unit) => {
        return Array.from(momentRange.by(unit));
    },
    getArrayOfUnitsWithFormat: (momentRange, unit, format) => {
        return exports.DateTimeFacade.getArrayOfUnits(momentRange, unit).map(m => m.format(format));
    },
    getArrayOfDatesWithFormat: (momentRange, format) => {
        return exports.DateTimeFacade.getArrayOfUnitsWithFormat(momentRange, "days", format);
    }
};
